// src/pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div style={{
      marginTop: '70px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'calc(100vh - 70px)',
      textAlign: 'left',
      padding: '2rem',
      width: '100%',
      position: 'relative',
      zIndex: 1
    }}>
      <div style={{ maxWidth: '800px', width: '100%' }}>
        <h2 style={{ 
          fontSize: '3rem', 
          color: '#007bff',
          marginBottom: '1.5rem'
        }}>Hi,</h2>
        <p style={{ 
          fontSize: '1.5rem', 
          lineHeight: '1.6',
          maxWidth: '600px',
          marginBottom: '2rem'
        }}>
          I turn your ideas into clear, <strong>user-friendly products</strong>.
          I love understanding <strong>people's needs</strong> and creating
          designs that work seamlessly for everyone.
        </p>
        <Link 
          to="/work" 
          className="cta-button"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            backgroundColor: '#007bff',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '4px',
            textDecoration: 'none',
            fontSize: '1.1rem',
            fontWeight: '500',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.3s ease',
            position: 'relative',
            overflow: 'hidden'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-3px)';
            const arrow = e.currentTarget.querySelector('.arrow');
            if (arrow) arrow.style.transform = 'translateX(4px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            const arrow = e.currentTarget.querySelector('.arrow');
            if (arrow) arrow.style.transform = 'translateX(0)';
          }}
        >
          See my work
          <span 
            className="arrow" 
            style={{
              marginLeft: '8px',
              transition: 'transform 0.3s ease',
              display: 'inline-block'
            }}
          >→</span>
        </Link>
      </div>
    </div>
  );
}

export default Home;